/* =============================================================================
   LOOMA — <looma-header> controller (spec §8)
   Sticky glass-on-scroll toggle. Vanilla, no console output.
   ========================================================================== */
(function () {
  'use strict';
  if (customElements.get('looma-header')) return;
  customElements.define('looma-header', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.onScroll = function () {
        self.classList.toggle('is-scrolled', (window.pageYOffset || document.documentElement.scrollTop) > 8);
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }
    disconnectedCallback() { window.removeEventListener('scroll', this.onScroll); }
  });
})();
